import React from 'react';
import { Section } from './ui/Section';
import { BookOpen, Coffee, Users, ShieldCheck, Sparkles } from 'lucide-react';
export function ProductBreakdown() {
  const features = [{
    icon: <BookOpen className="w-6 h-6 text-rose-500" data-id="element-142" />,
    title: 'El sistema Semáforo completo',
    desc: 'Explicado sin lenguaje médico. Con ejemplos reales de LatAm.'
  }, {
    icon: <Coffee className="w-6 h-6 text-rose-500" data-id="element-143" />,
    title: 'Plantillas (no recetas eternas)',
    desc: 'Combinaciones rápidas que funcionan para tu vida ocupada.'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-rose-500" data-id="element-144" />,
    title: "La 'Escalera del Antojo'",
    desc: 'Qué hacer en 90 segundos cuando el antojo está en 8/10.'
  }, {
    icon: <Sparkles className="w-6 h-6 text-rose-500" data-id="element-145" />,
    title: 'Protocolo de 14 días',
    desc: "Enfoque en tardes/noches, ansiedad por dulce y 'me lo merezco'."
  }, {
    icon: <Users className="w-6 h-6 text-rose-500" data-id="element-146" />,
    title: 'Supervivencia social',
    desc: 'Porque comes con familia, pareja y en la oficina. Plan real.'
  }];
  return <div className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-147">
      <div className="max-w-6xl mx-auto" data-id="element-148">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-149">
          <Section data-id="element-150">
            <h2 className="text-3xl md:text-4xl font-serif text-stone-900 mb-6" data-id="element-151">
              Lo que incluye el Reset
            </h2>
            <p className="text-lg text-stone-600 mb-10" data-id="element-152">
              Este no es un libro para leer "algún día". Es un manual para usar
              cuando la vida está encima.
            </p>

            <div className="space-y-6" data-id="element-153">
              {features.map((feature, idx) => <div key={idx} className="flex items-start" data-id="element-154">
                  <div className="flex-shrink-0 p-2 bg-rose-50 rounded-lg mr-4" data-id="element-155">
                    {feature.icon}
                  </div>
                  <div data-id="element-156">
                    <h4 className="font-bold text-stone-900" data-id="element-157">
                      {feature.title}
                    </h4>
                    <p className="text-stone-600 text-sm" data-id="element-158">{feature.desc}</p>
                  </div>
                </div>)}
            </div>
          </Section>

          <Section delay={200} className="relative" data-id="element-159">
            <div className="relative" data-id="element-160">
              <div className="absolute -inset-4 bg-rose-100 rounded-full blur-2xl opacity-60" data-id="element-161"></div>
              <img src="https://cdn.magicpatterns.com/uploads/jGztxmJKRNV8ZWJ3qMsyZc/Imagen_3.png" alt="Mujeres viendo el plan en tablet" className="relative rounded-2xl shadow-2xl w-full transform hover:scale-[1.02] transition-transform duration-500" data-id="element-162" />
            </div>
          </Section>
        </div>

        {/* Transformation */}
        <Section className="bg-[#FFF5F0] rounded-3xl p-8 md:p-16 text-center" data-id="element-163">
          <h2 className="text-3xl font-serif text-stone-900 mb-12" data-id="element-164">
            Cómo se ve el cambio en 14 días
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-165">
            <div className="p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow" data-id="element-166">
              <p className="text-rose-500 font-serif text-xl italic mb-4" data-id="element-167">
                "El antojo aparece..."
              </p>
              <p className="text-stone-600" data-id="element-168">
                ...pero ya no te arrastra. Tienes herramientas para gestionarlo
                sin perder el control.
              </p>
            </div>
            <div className="p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow" data-id="element-169">
              <p className="text-rose-500 font-serif text-xl italic mb-4" data-id="element-170">
                "Tu tarde..."
              </p>
              <p className="text-stone-600" data-id="element-171">
                ...ya no es una caída libre. Te sientes más estable y con
                energía constante.
              </p>
            </div>
            <div className="p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow" data-id="element-172">
              <p className="text-rose-500 font-serif text-xl italic mb-4" data-id="element-173">
                "Tu mente..."
              </p>
              <p className="text-stone-600" data-id="element-174">
                ...se calla un poco. Empiezas a confiar en ti otra vez. Eso es
                enorme.
              </p>
            </div>
          </div>
        </Section>
      </div>
    </div>;
}